import { render, staticRenderFns } from "./DoctorDetail.vue?vue&type=template&id=7b0de035&scoped=true&"
import script from "./DoctorDetail.vue?vue&type=script&lang=js&"
export * from "./DoctorDetail.vue?vue&type=script&lang=js&"
import style0 from "./DoctorDetail.vue?vue&type=style&index=0&id=7b0de035&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0de035",
  null
  
)

export default component.exports